import "bootstrap/js/dist/dropdown";
import { gsap } from "gsap";

import "./styles.scss";

// Basic exovia bootstrap improvement

const myDropdownsBtns = [...document.querySelectorAll(".dropdown-toggle")];
myDropdownsBtns.forEach((dropdown) => {
  dropdown.addEventListener("show.bs.dropdown", () => {
    gsap.from(dropdown.nextElementSibling, {
      autoAlpha: 0,
      y: 35,
      duration: 0.25,
    });
  });
  dropdown.addEventListener("hide.bs.dropdown", () => {
    gsap.set(dropdown.nextElementSibling, {
      display: "block",
      left: "auto",
      right: 0,
    });
    gsap.to(dropdown.nextElementSibling, {
      y: 35,
      autoAlpha: 0,
      duration: 0.25,
      onComplete() {
        gsap.set(dropdown.nextElementSibling, { display: "", autoAlpha: 1, left: "", right: "", y: "" });
      },
    });
  });
});
